import { render } from "./App.vue?vue&type=template&id=60d4c5da"
const script = {}

import "./App.vue?vue&type=style&index=0&id=60d4c5da&lang=less"

import exportComponent from "/Users/junyichen/AffaMed/hda-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__